import { Text } from "@mantine/core";
import { DatePicker, DateRangePicker } from "@mantine/dates";

import dayjs from "dayjs";
import "dayjs/locale/vi";
import customParseFormat from "dayjs/plugin/customParseFormat";
import moment from "moment";
import { useEffect, useState } from "react";
import styles from "../../styles/dynamic-form.module.scss";
import { getDescriptionStyleJSX } from "../nonPrimitiveType/formDynamicInput";

function FormDynamicInputDate(props) {
  if (props.inputTemplate) {
    if (props.inputTemplate.type === "date") {
      if (props.inputTemplate.mode == "date-range") {
        return <FormDynamicInputDateRangeHelper {...props} />;
      }
      return <FormDynamicInputDateHelper {...props} />;
    } else {
      return <></>;
    }
  }
}

function FormDynamicInputDateHelper(props) {
  const [hasDateCustomError, setHasDateCustomError] = useState(false);
  const [oldInvisible, setOldInvisible] = useState(false);

  const inputTemplate = props.inputTemplate;
  let inputProps = { ...props.formInputProps };
  const defaultDate =
    !inputProps.value ||
    new Date(inputProps.value).toString() === "Invalid Date"
      ? ""
      : new Date(inputProps.value);

  dayjs.extend(customParseFormat);

  inputProps.value = defaultDate;
  inputProps.onChange = (valueDate) => {
    if (valueDate) {
      const momentObject = moment(valueDate, customDateFormat, "vi");

      switch (customDateFormat) {
        case "MM/YYYY":
          momentObject.date(1);
          break;

        case "YYYY":
          momentObject.dayOfYear(1);
          break;

        default:
          break;
      }
      if (
        momentObject.year() >= (inputTemplate.minYear || 1900) &&
        momentObject.year() <= (inputTemplate.maxYear || 2100)
      ) {
        setHasDateCustomError(false);
        props.setHasCustomError(false);
      }

      props.formInputProps.onChange(momentObject.toDate());
    } else {
      if (valueDate === null) props.formInputProps.onChange("");
      else {
        props.formInputProps.onChange(valueDate);
        setHasDateCustomError(true);
        props.setHasCustomError(true);
      }
    }
  };

  useEffect(() => {
    if (inputTemplate.invisible) {
      setOldInvisible(true);
      props.formInputProps.onChange(undefined);
      setHasDateCustomError(false);
      props.setHasCustomError(false);
    } else if (oldInvisible) {
      setOldInvisible(false);
      props.formInputProps.onChange(props.initialValue);
    }
  }, [inputTemplate.invisible]);
  const customDateFormat = inputTemplate.dateFormat ?? "DD/MM/YYYY";

  useEffect(() => {
    if (
      props.formInputProps.value === undefined &&
      !inputTemplate.invisible &&
      !props.initialValue
    ) {
      props.formInputProps.onChange("");
    }
  }, [props.formInputProps.value]);

  if (inputTemplate.invisible) {
    return <></>;
  }
  return (
    <>
      <DatePicker
        className={`${styles.formDynamicTextDateSelectInput} formDynamicTextDateSelectInput`}
        allowFreeInput={true}
        locale="vi"
        dateParser={(value) => {
          if (hasDateCustomError) {
            setHasDateCustomError(false);
            props.setHasCustomError(false);
          }
          if (value.length === 0) {
            return null;
          }
          const momentObject = moment(value, customDateFormat, "vi");
          if (momentObject.isValid()) {
            if (
              momentObject.year() < (inputTemplate.minYear || 1900) ||
              momentObject.year() > (inputTemplate.maxYear || 2100)
            ) {
              setHasDateCustomError(true);
              props.setHasCustomError(true);
              return momentObject.toDate();
            }

            return momentObject.toDate();
          } else {
            return undefined;
          }
        }}
        label={
          inputTemplate.labelNoWrap ? (
            <span style={{ textWrap: "nowrap" }}>{inputTemplate.label}</span>
          ) : (
            inputTemplate.label
          )
        }
        description={getDescriptionStyleJSX(inputTemplate)}
        dropdownPosition={"bottom-start"}
        withAsterisk={props.requiredInput}
        inputFormat={customDateFormat}
        placeholder={
          inputTemplate.placeholder
            ? inputTemplate.placeholder
            : inputTemplate.label
        }
        {...inputProps}
        disabled={props.disabledInput || inputProps.disabled}
        minDate={inputTemplate.minToday && dayjs(new Date()).toDate()}
        maxDate={inputTemplate.maxToday && dayjs(new Date()).toDate()}
      />
      {hasDateCustomError ? (
        <Text c={"red"} fz={12}>
          Ngày nhập không đúng định dạng
        </Text>
      ) : (
        <></>
      )}
    </>
  );
}

function FormDynamicInputDateRangeHelper(props) {
  const [hasDateCustomError, setHasDateCustomError] = useState(false);
  const [range, setRange] = useState([null, null]);

  const inputTemplate = props.inputTemplate;
  const inputProps = { ...props.formInputProps };
  const customDateFormat = inputTemplate.dateFormat ?? "DD/MM/YYYY";

  if (inputProps.value) {
    inputProps.value = inputProps.value.map((v) =>
      v instanceof Date ? v : v ? new Date(v) : null
    );
  }

  inputProps.onChange = (value) => {
    setRange(value);
    props.formInputProps.onChange(value);
    /*
          date range selection is only valid if:
          - isn't required BUT only [null, null] & [Date, Date] are allowed
          - is required and [Date, Date]
          */
    const isRequired = props.requiredInput;
    const isOnlyOneNull = (value[0] === null) !== (value[1] === null);
    const isValid =
      (!isRequired && !isOnlyOneNull) || (isRequired && !value.includes(null));
    setHasDateCustomError(!isValid);
    props.setHasCustomError(!isValid);
  };

  useEffect(() => {
    if (props.initialValue) {
      const [start, end] = props.initialValue;
      setRange([start ? new Date(start) : null, end ? new Date(end) : null]);
    }
  }, [props.initialValue]);

  return (
    <>
      <DateRangePicker
        className={`${styles.formDynamicTextDateSelectInput} formDynamicTextDateSelectInput`}
        locale="vi"
        label={
          inputTemplate.labelNoWrap ? (
            <span style={{ textWrap: "nowrap" }}>{inputTemplate.label}</span>
          ) : (
            inputTemplate.label
          )
        }
        withAsterisk={props.requiredInput}
        placeholder={
          inputTemplate.placeholder
            ? inputTemplate.placeholder
            : inputTemplate.label
        }
        {...inputProps}
        description={getDescriptionStyleJSX(inputTemplate)}
        inputFormat={customDateFormat}
        disabled={props.disabledInput || inputProps.disabled}
      />
      {hasDateCustomError ? (
        <Text c={"red"} fz={12}>
          Phải có ngày bắt đầu và kết thúc
        </Text>
      ) : (
        <></>
      )}
    </>
  );
}

export default FormDynamicInputDate;
